import { render, staticRenderFns } from "./BatchIndex.vue?vue&type=template&id=3eb14180"
import script from "./BatchIndex.vue?vue&type=script&lang=ts"
export * from "./BatchIndex.vue?vue&type=script&lang=ts"
import style0 from "./BatchIndex.vue?vue&type=style&index=0&id=3eb14180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports